import React from 'react';
import { constants } from '../../lib';
import FiverrContext from '../FiverrContext';
import propTypes from './propTypes';

/**
 * A unified renderer function for both React 15 and React 16 runtimes.
 * @param  {String} children The component's content.
 * @param  {String} locale The session locale.
 * @return {String|HTMLSpanElement} Rendered children with a contextualized i18n function.
 */
const render = ({ children, locale = constants.DEFAULT_LOCALE }) => {
    const contextualizedI18n = i18n.spawn(locale);

    return children({ i18n: contextualizedI18n });
};

const I18nProvider = ({ children }) => {
    const { locale } = React.useContext(FiverrContext);

    return render({ children, locale });
};

const I18nWrapper = (props) => (
    typeof React.useContext !== 'function'
        ? render(props)
        : <I18nProvider {...props}/>
);

I18nProvider.propTypes = {
    ...propTypes
};

I18nWrapper.propTypes = {
    ...propTypes
};

export default I18nWrapper;
